import React, { useState } from 'react';
import Lottie from 'lottie-react-web';
import PropTypes from 'prop-types';
import Icon from '@mdi/react';
import { mdiCropFree, mdiClose } from '@mdi/js';
import {
  ATTACHMENT_TYPES,
  VIMEO_URL,
  VIMEO_VIDEO_STATUS,
} from '../utils/constants';
import loading from '../img/video.json';
import Carrousel, { CarouselItem } from './Carrousel';
import ImageFullScreen from './ImageFullScreen';

const Gallery = ({ data }) => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const toggleOpenFullScreenImage = () => {
    setOpen(!open);
  };

  const checkVimeoUrl = (preview) => {
    if (preview.startsWith(VIMEO_URL.URL_VIMEO)) {
      return `${preview}`;
    }
    return `${VIMEO_URL.URL_VIMEO}${preview}`;
  };

  const youtubeContent = (preview) => {
    return (
      <iframe
        title="YouTube video"
        src={`https://www.youtube.com/embed/${preview}`}
        frameBorder="0"
        allowFullScreen
      />
    );
  };

  const vimeoContent = (preview) => {
    return (
      <iframe
        className="frame-vimeo"
        title="Vimeo video"
        src={checkVimeoUrl(preview)}
      />
    );
  };

  const renderItem = (item) => {
    let content = '';
    switch (item.type) {
      case ATTACHMENT_TYPES.YOUTUBE:
        content = (
          <div className="iframe-wrapper">{youtubeContent(item.preview)}</div>
        );
        break;
      case ATTACHMENT_TYPES.VIMEO:
        content =
          item.status === VIMEO_VIDEO_STATUS.COMPLETE ? (
            <div className="iframe-wrapper">{vimeoContent(item.preview)}</div>
          ) : (
            <div className="iframe-wrapper">
              <Lottie
                options={{
                  animationData: loading,
                }}
              />
            </div>
          );
        break;
      default:
        content = (
          <div className="image-gallery-image">
            <img alt={item.fileName} className="image" src={item.preview} />
          </div>
        );
    }

    return (
      <>
        {content}
        <button
          className="full-screen-image-action"
          type="button"
          onClick={toggleOpenFullScreenImage}
        >
          <Icon path={mdiCropFree} size={1} color="#FFF" />
        </button>
      </>
    );
  };

  const getFullScreenContent = (item) => {
    switch (item.fileType) {
      case ATTACHMENT_TYPES.IMAGE:
        return (
          <img src={item.preview} className="carousel-image" alt="Gallery" />
        );
      case ATTACHMENT_TYPES.YOUTUBE:
        return <>{youtubeContent(item.preview)}</>;
      case ATTACHMENT_TYPES.VIMEO:
        return <>{vimeoContent(item.preview)}</>;
      default:
        return <></>;
    }
  };

  const whatsCurrentIndex = (currentIndex) => {
    setIndex(currentIndex);
  };

  const getIndexItem = (status) => {
    return Number(status.step) - 1;
  };

  const getStatusCarousel = (status) => {
    setIndex(getIndexItem(status));
  };

  return data.length ? (
    <div className="gallery">
      <ImageFullScreen open={open} onClose={toggleOpenFullScreenImage}>
        <div className="full-screen-image-wrapper">
          <button
            className="action"
            type="button"
            onClick={toggleOpenFullScreenImage}
          >
            <Icon path={mdiClose} size={1} color="#FFF" />
          </button>
          <div className="full-screen-image-carousel">
            <Carrousel
              showStatus={false}
              initialActiveStep={index + 1}
              status={getStatusCarousel}
            >
              {data.map((item, indexItem) => (
                <CarouselItem key={`${item.fileName}-${indexItem + 1}`}>
                  <div className="carousel-image-scroll">
                    {getFullScreenContent(item)}
                  </div>
                </CarouselItem>
              ))}
            </Carrousel>
          </div>
        </div>
      </ImageFullScreen>
      <Carrousel showStatus={false} whatsCurrentIndex={whatsCurrentIndex}>
        {data.map((item, indexItem) => (
          <CarouselItem key={`${item.fileName}-${indexItem + 1}`}>
            <>{renderItem(item)}</>
          </CarouselItem>
        ))}
      </Carrousel>
    </div>
  ) : null;
};

Gallery.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      fileName: PropTypes.string,
      fileType: PropTypes.string,
      preview: PropTypes.string,
      status: PropTypes.string,
      type: PropTypes.string,
    })
  ).isRequired,
};

export default Gallery;
